/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum InsightsDriverBreakdownSortingCriteria {
  DRIVER_NAME="DRIVER_NAME",
COMPLETED_ROUTES="COMPLETED_ROUTES",
COMPLETED_ORDERS="COMPLETED_ORDERS",
ESTIMATED_DISTANCE="ESTIMATED_DISTANCE",
WORKING_TIME="WORKING_TIME"
}

/**
* InsightsDriverBreakdownSortingCriteria
*/
export const InsightsDriverBreakdownSortingCriteriaEnumType = types.enumeration("InsightsDriverBreakdownSortingCriteria", [
        "DRIVER_NAME",
  "COMPLETED_ROUTES",
  "COMPLETED_ORDERS",
  "ESTIMATED_DISTANCE",
  "WORKING_TIME",
      ])
